import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import PageMeta from '../../modules/PageMeta';
import PageSection from '../../modules/PageSection';
import SidebarColumn from '../../modules/SidebarColumn';
import ContentColumn from '../../modules/ContentColumn';
import PageSidebar from '../../modules/PageSidebar';
import Page from '../../pages/Page';
import LicenceForm from '../../forms/Licence';

import * as licenceActions from '../../../actions/licences';
import qs from "query-string";

import styles from './styles.scss';

class AdminNewLicence extends React.Component {

    constructor() {
        super();

        this.state = {
            redirectOnSuccessTo: null
        }
    }

    _createLicence(params) {

        const { assignService, licenceTypeKey } = qs.parse(this.props.location.search);

        const isAssigningToService = assignService && licenceTypeKey;

        if (isAssigningToService) {
            params = {...params, assign_service_id: assignService, licence_type_key: licenceTypeKey};
        }

        return this.props.createLicence(params)
            .then(() => {

                // Put navigation to the back of the queue to avoid form success state issues
                setTimeout(() => {
                    if (isAssigningToService) {
                        this.props.history.push(`/admin/licences?serviceId=${assignService}`);
                    } else {
                        this.props.history.push(`/admin/manage-licences`);
                    }
                }, 0);
            });
    }

    render() {

        return (
            <Page>
                <PageMeta title="New Licence" />

                <SidebarColumn>
                    <PageSidebar />
                </SidebarColumn>

                <ContentColumn>

                    <PageSection>

                        <Link className={styles['back-to-licences']} to="/admin/licences">
                            &larr; Back to service licences
                        </Link>

                        <LicenceForm onSubmit={this._createLicence.bind(this)} />

                    </PageSection>

                </ContentColumn>
            </Page>
        )
    }
}

const mapStateToProps = () => {
    return {}
};

const mapDispatchToProps = (dispatch) => {
    return {
        createLicence(params) {
            return dispatch(licenceActions.createLicence(params));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminNewLicence);